import React from 'react';
import StatusBadge from './StatusBadge';
import { CheckCircle2, Circle, Loader2, XCircle, RotateCcw } from 'lucide-react';

const STEP_ICONS = {
  pending: Circle,
  running: Loader2,
  completed: CheckCircle2,
  failed: XCircle,
  retrying: RotateCcw,
};

export default function ProjectSteps({ steps = [], currentStep = 0, onSelectStep }) {
  if (steps.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground text-sm">
        Aucune étape pour le moment
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {steps.map((step, index) => {
        const Icon = STEP_ICONS[step.status] || Circle;
        const isActive = step.step_number === currentStep;
        const isRunning = step.status === 'running';

        return (
          <button
            key={step.id || index}
            onClick={() => onSelectStep?.(step)}
            className={`w-full flex items-start gap-3 p-3 rounded-lg text-left transition-colors ${
              isActive ? 'bg-accent' : 'hover:bg-accent/50'
            }`}
          >
            {/* Timeline */}
            <div className="flex flex-col items-center pt-0.5">
              <div className={`p-1 rounded-full ${
                step.status === 'completed' ? 'bg-emerald-500/10' :
                step.status === 'failed' ? 'bg-red-500/10' :
                isRunning ? 'bg-blue-500/10' :
                'bg-muted'
              }`}>
                <Icon className={`w-4 h-4 ${
                  step.status === 'completed' ? 'text-emerald-400' :
                  step.status === 'failed' ? 'text-red-400' :
                  isRunning ? 'text-blue-400 animate-spin' :
                  'text-muted-foreground'
                }`} />
              </div>
              {index < steps.length - 1 && (
                <div className={`w-px flex-1 min-h-[16px] mt-1 ${
                  step.status === 'completed' ? 'bg-emerald-500/30' : 'bg-border'
                }`} />
              )}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-foreground">
                  Étape {(step.step_number ?? index) + 1}
                </span>
                <StatusBadge status={step.status} size="sm" showIcon={false} />
              </div>
              <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">
                {step.description || 'En cours de traitement...'}
              </p>
              {step.model_used && (
                <span className="text-[10px] text-muted-foreground/70 mt-1 inline-block">
                  {step.model_used}
                  {step.cost_eur > 0 && ` · ${step.cost_eur.toFixed(4)}€`}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
